import axios from 'axios'

export default {
  dealerWait () {
    return axios.get('/deliver/dealer-wait')
  }
}
